"use strict";

(function () {
  "use strict";

  angular.module("fleetviewApp").directive("alkMainNav", alkMainNav);

  alkMainNav.$inject = [];

  var config = require("config");

  function alkMainNav() {
    // Usage:
    //
    // Creates:
    //
    var directive = {
      bindToController: true,
      controller: alkMainNavController,
      controllerAs: "vm",
      restrict: "E",
      scope: {},
      template: require("./nav.html")
    };

    return directive;
  }
  /* @ngInject */
  alkMainNavController.$inject = ["$rootScope", "$location", "alkAuthenticationService", "mapService", "$state", "$transitions", "alkModalService", "$q", "$translate", "LayoutService", "cacheService", "UserProvider"];

  function alkMainNavController($rootScope, $location, alkAuthenticationService, mapService, $state, $transitions, alkModalService, $q, $translate, LayoutService, cacheService, userProvider) {
    var vm = this;

    vm.gotoCompliance = gotoCompliance;
    vm.gotoReports = gotoReports;
    vm.isComplianceSelected = false;
    vm.showCompliance = true;
    vm.isleftPanelHidden = false;
    vm.hidePanel = hidePanel;
    vm.reportsSelected = false;
    vm.userInfo = $rootScope.userInfo;

    function gotoCompliance() {
      $state.go("main.compliance");
      LayoutService.openLeftHandPanel(500);
      vm.isComplianceSelected = true;
    }

    function gotoReports() {
      $state.go("reports.groups");
    }

    function hidePanel() {
      if (!vm.isleftPanelHidden) {
        LayoutService.closeLeftHandPanel();
        vm.isleftPanelHidden = true;
      } else {
        LayoutService.openLeftHandPanel(500);
        vm.isleftPanelHidden = false;
      }
    }

    vm.stateIncludes = function (stateStr) {
      return $state.includes(stateStr);
    };

    vm.newRRWeb = function () {
      return config.newRRWeb + "?token=" + userProvider.getUser().authToken;
    };

    $transitions.onBefore({}, function (trans) {
      return allowTransition(trans).then(function () {
        return true;
      }, function () {
        return false;
      });
    });

    function allowTransition(trans) {
      return $q(function (resolve, reject) {
        resolve(true);
        $rootScope.$broadcast("panelClosed", {
          name: trans.$from().name
        });
      });
    }

    vm.showTracks = false;

    vm.changeMapStyle = function (style) {
      mapService.setStyle(style);
    };

    vm.canEdit = function () {
      return true;
    };

    vm.goToAccount = function () {
      $state.go("user");
    };

    vm.goToAdmin = function () {
      $state.go("company");
    };

    vm.goToDashboard = function () {
      $state.go("dashboard");
    };
    vm.cAdmin = function () {
      $state.go("companyadmin");
    };

    vm.onLogOut = function () {
      var userString = window.sessionStorage["userAuthInfo"];
      var user = JSON.parse(userString);
      var tidToken = window.localStorage["trimbleIdToken"];
      var baseUrl = window.location.protocol + "//" + window.location.host;

      if (tidToken) {
        var url = config.trimbleCloudUrl + "oauth/logout?";
        url += "post_logout_redirect_uri=" + baseUrl + "/tid/logout";
        url += "&id_token_hint=" + tidToken;

        window.location.href = url;

        alkAuthenticationService.logout(user.authToken).then(function () {
          window.sessionStorage["logoutInProgress"] = true;
          //$state.go("login");
          window.location.replace("/");
        });
      } else {
        alkAuthenticationService.logout(user.authToken).then(function () {
          window.sessionStorage["logoutInProgress"] = true;
          //$state.go("login");
          window.location.replace("/");
        });
      }
      cacheService.clearForLogout();
    };

    vm.quickStart = function () {
      $rootScope.$broadcast("toggleStart");
    };

    $rootScope.$on("hideCompliance", function (event, message) {
      vm.showCompliance = false;
    });

    setTimeout(function () {
      var logoutButton = document.getElementById("logoutButton");
      var newLogOutButton = "<a id=\"logoutButton\" class=\"btn btn-xs btn-default pull-right cloud-menu-btn cloud-menu-btn-last ng-scope\" alk-analytics=\"['Logout']\" onclick=\"window.location.replace('" + baseUrl() + "/logout');\" translate=\"common.nav.Logout\">Logout</a>";
      logoutButton.remove();
      var changePassButton = document.getElementById("changePasswordButton");
      changePassButton.insertAdjacentHTML("beforebegin", newLogOutButton);
      changePassButton.remove();
    });

    function baseUrl() {
      return "" + (window.location.protocol + "//" + window.location.host);
    }
  }
})();


// WEBPACK FOOTER //
// ./app/layout/nav.directive.js